var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCrowdvotingFoerdersummenVisualisierungInlineRgb = function SvgCrowdvotingFoerdersummenVisualisierungInlineRgb(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 330,
    height: 180,
    viewBox: "0 0 330 180",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M137.54,1.47H7.83C3.61,1.47,0,4.99,0,9.4v58.79c0,4.21,3.51,7.83,7.83,7.83h31.6c.8,0,1.3.8.9,1.5l-16.65,35.21c-.9,2.01,1.5,4.01,3.21,2.71l51.37-39.03c.1-.1.4-.3.7-.3h58.59c4.31,0,7.93-3.41,7.93-7.83V9.2c0-4.21-3.41-7.83-7.83-7.83h0v.1h-.1Z",
    style: {
      fill: "#e8e171"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.78,113.94c2.91,1.5,5.72,2.11,9.13,2.11s7.22-1.71,7.22-6.22-2.91-5.22-6.52-6.72l-2.91-1.4c-3.71-1.81-6.72-4.21-6.72-9.33,0-7.42,6.52-10.53,12.34-10.53s5.92.3,8.53,1.2l-.4,4.92c-2.51-1.1-5.32-1.5-7.83-1.5s-6.72,1.3-6.72,5.52,2.51,4.51,5.22,5.82l3.11,1.4c4.51,2.11,7.93,4.31,7.93,10.23s-5.82,11.24-12.94,11.24-6.52-.5-9.73-1.5l.2-5.22h.1Z",
    style: {
      fill: "#008c57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.73,119.86c-1.81.6-3.61.9-5.42.9-6.02,0-7.22-4.11-7.22-9.73v-15.15h-5.22v-4.01h5.22v-6.12l5.62-1.91v7.93h6.42v4.01h-6.42v15.85c0,2.51.6,4.51,3.51,4.51s2.11-.2,3.11-.7l.2,4.11v.2h.1l.1.1Z",
    style: {
      fill: "#008c57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.74,86.05v-5.42h5.62v5.42h-5.62ZM167.74,120.16v-28.19h5.62v28.19h-5.62Z",
    style: {
      fill: "#008c57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.08,120.16v-21.77c0-2.21,0-4.21-.2-6.52h5.32v4.82c2.01-3.71,4.92-5.42,8.83-5.42s7.32,2.61,8.23,5.82c1.3-3.51,5.12-5.82,8.63-5.82,6.12,0,8.93,4.11,8.93,10.03v18.76h-5.62v-18.16c0-3.41-1.1-6.22-5.12-6.22s-6.22,4.61-6.22,8.93v15.45h-5.62v-18.16c0-3.41-1.1-6.22-5.12-6.22s-6.42,4.61-6.42,8.93v15.45h-5.62v.1Z",
    style: {
      fill: "#008c57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.54,120.16v-21.77c0-2.21,0-4.21-.2-6.52h5.32v4.82c2.01-3.71,4.92-5.42,8.83-5.42s7.32,2.61,8.23,5.82c1.3-3.51,5.12-5.82,8.63-5.82,6.12,0,8.93,4.11,8.93,10.03v18.76h-5.62v-18.16c0-3.41-1.1-6.22-5.12-6.22s-6.22,4.61-6.22,8.93v15.45h-5.62v-18.16c0-3.41-1.1-6.22-5.12-6.22s-6.42,4.61-6.42,8.93v15.45h-5.62v.1Z",
    style: {
      fill: "#008c57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280,107.32c0,5.22,3.21,9.53,9.43,9.53s5.32-.6,7.62-1.81l.4,4.11c-2.61,1.1-5.62,1.5-8.73,1.5-9.53,0-14.45-6.02-14.45-14.85s4.82-14.55,12.94-14.55,11.84,6.22,11.84,14.25v1.71h-19.16l.1.1ZM293.45,103.81c0-4.21-1.3-8.53-6.42-8.53s-7.12,4.51-7.22,8.53h13.64Z",
    style: {
      fill: "#008c57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.68,120.16v-21.77c0-2.21,0-4.21-.2-6.52h5.32v4.82c2.11-3.71,5.22-5.42,9.33-5.42,6.92,0,9.43,4.31,9.43,10.94v17.86h-5.62v-16.65c0-3.91-.8-7.83-5.52-7.83s-6.82,4.61-6.82,9.13v15.35h-5.82l-.1.1Z",
    style: {
      fill: "#008c57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.25,162.19v-5.72h28.09v5.72h-28.09ZM76.25,174.23v-5.72h28.09v5.72h-28.09Z",
    style: {
      fill: "#008c57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1,61.13V22.6l-8.43,6.86-5-6.51,14.58-11.72h8.86v49.89h-10.01Z",
    style: {
      fill: "#008c57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.25,36.33c0-15.72,5.65-25.95,17.3-25.95s17.44,9.01,17.44,25.95-6,25.66-17.44,25.66-17.3-8.15-17.3-25.66ZM76.98,36.33c0-7.5-.21-18.51-7.51-18.51-6.79,0-7.22,10.58-7.22,18.3s.29,18.44,7.29,18.44,7.43-10.79,7.43-18.23Z",
    style: {
      fill: "#008c57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.99,36.33c0-15.72,5.65-25.95,17.3-25.95s17.44,9.01,17.44,25.95-6,25.66-17.44,25.66-17.3-8.15-17.3-25.66ZM116.72,36.33c0-7.5-.21-18.51-7.51-18.51-6.79,0-7.22,10.58-7.22,18.3s.29,18.44,7.29,18.44,7.43-10.79,7.43-18.23Z",
    style: {
      fill: "#008c57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.25,178v-6.05l4.35-4.03c6.93-6.47,11.28-12.16,11.28-16.09,0-3.1-2.69-4.86-5.9-4.86-2.48,0-5.22.88-8.33,2.9l-.57-6c3.31-1.65,6.98-2.59,10.71-2.59,7.19,0,11.33,3.78,11.33,10.55,0,5.02-2.9,10.5-13.6,20.48h14.74v5.69h-24Z",
    style: {
      fill: "#008c57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.76,171.12c3,1.29,5.22,1.81,7.29,1.81,4.6,0,7.81-2.28,7.81-6.36s-3.15-6.26-8.28-6.26c-2.22,0-4.35.31-6.47.98l.36-19.4h20.74v5.38h-13.91l-.16,7.71c1.24-.21,2.02-.36,3.31-.36,6.47,0,11.64,3.57,11.64,11.69,0,7.4-5.38,12.31-14.07,12.31-2.33,0-5.69-.36-8.43-1.04l.15-6.47Z",
    style: {
      fill: "#008c57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.45,160.06c0-11.38,4.09-18.78,12.52-18.78s12.62,6.52,12.62,18.78-4.34,18.57-12.62,18.57-12.52-5.9-12.52-18.57ZM196.35,160.06c0-5.43-.16-13.4-5.43-13.4-4.91,0-5.22,7.66-5.22,13.24s.21,13.35,5.28,13.35,5.38-7.81,5.38-13.19Z",
    style: {
      fill: "#008c57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.97,178v-36.1h21.31v5.69h-14.07v8.9h12.88v5.69h-12.88v10.14h14.17v5.69h-21.41Z",
    style: {
      fill: "#008c57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270,178v-3.62h-.1c-2.28,2.74-5.28,4.24-8.74,4.24-5.95,0-9.05-3.98-9.05-10.45v-16.81h6.93v15.21c0,5.33,1.97,6.67,4.5,6.67,4.19,0,6.1-3.88,6.1-9v-12.88h6.93v26.64h-6.57Z",
    style: {
      fill: "#008c57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.86,178v-26.64h6.16v6.05h.1c.41-2.79,3.31-6.67,7.35-6.67,1.45,0,1.86.16,2.07.21v6.98c-.62-.36-1.86-.57-3.1-.57-2.59,0-5.64,1.4-5.64,9.67v10.97h-6.93Z",
    style: {
      fill: "#008c57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.03,178.63c-8.59,0-13.91-5.9-13.91-13.76,0-8.54,5.79-14.12,13.91-14.12s13.97,5.53,13.97,14.12c0,7.91-5.38,13.76-13.97,13.76ZM322.76,164.04c0-4.24-2.28-7.91-6.72-7.91s-6.67,3.72-6.67,7.91c0,5.64,2.17,9.21,6.67,9.21s6.72-3.46,6.72-9.21Z",
    style: {
      fill: "#008c57"
    }
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCrowdvotingFoerdersummenVisualisierungInlineRgb);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/crowdvoting-foerdersummen-visualisierung-inline-rgb.7585235a0570f4d3c2e542eeb205c213.svg";